<template>
<div class="chapter">
<div class="inner_page">
<div class="contents" id="toc">
<p class="TOC-Title"><span class="bold">Contents</span></p>
<p class="chapImage"><img alt="images" src="images/chapicon.jpg"/></p>
<p class="TOC_paraNoIndent1"><a href="#/006_acknowledgements">Acknowledgements</a></p>
<p class="TOC_paraNoIndent1"><a href="#/007_introduction">Introduction</a></p>
<p class="TOC_paraNoIndent"><a href="#/008_ch01"><span class="bold">1</span> Carlisle before August 1914</a></p>
<p class="TOC_paraNoIndent"><a href="#/011_ch02"><span class="bold">2</span> 1914 July: Last days of normality</a></p>
<p class="TOC_paraNoIndent"><a href="#/012_ch03"><span class="bold">3</span> 1914 August to December: Over by Christmas?</a></p>
<p class="TOC_paraNoIndent"><span href="#/026_ch04" title="Link target outside of Sample"><span class="bold">4</span> 1915: War Comes to Carlisle</span></p>
<p class="TOC_paraNoIndent"><span href="#/074_ch05" title="Link target outside of Sample"><span class="bold">5</span> 1916: Social Changes and Military Losses</span></p>
<p class="TOC_paraNoIndent"><span href="#/107_ch06" title="Link target outside of Sample"><span class="bold">6</span> 1917: War Routines, Local Services</span></p>
<p class="TOC_paraNoIndent"><span href="#/151_ch07" title="Link target outside of Sample"><span class="bold">7</span> 1918: Turmoil and Triumph</span></p>
<p class="TOC_paraNoIndent"><span href="#/173_ch08" title="Link target outside of Sample"><span class="bold">8</span> Afterword, 1919 and Beyond</span></p>
<p class="TOC_paraNoIndent1"><span href="#/183_bibliography" title="Link target outside of Sample">Bibliography</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 005_toc.vue?a462ea54